// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"O4-z","dimensionLabel":"P4-z","styleChooserControlWrapper":"Q4-z","styleChooserControl":"R4-z","disabled":"S4-z","giftCard":"T4-z","styleChooserText":"U4-z"};